import { DeclineWordType } from 'Src/Utils/declineWordByNumber';

/**
 *  Промежуток времени ( между down и up событиями мыши в мс )
 *  при превышении которого клик будет игнорироваться
 *  необходимо для реализации выделения текста в таблицах, без перехода в карточку
 */
export const MOUSE_CLICK_TIMESTAMP = 150;

export const ENDPOINTS = {
	/**
	 * Получение информации о текущем пользователе,
	 * его ролях, правах и версии приложения
	 */
	GET_CURRENT_USER_INFO:
		'/Nvx.ReDoc.WebInterfaceModule/Controller/DefaultController/ContactInfoBase',
};

export const DECLINE_DAY: DeclineWordType = ['день', 'дня', 'дней'];

export const DECLINE_SYMBOL: DeclineWordType = ['символ', 'символа', 'символов'];
